export default __webpack_public_path__ + "static/media/merge-manta-418.120942b6.svg";